import { useState, useEffect } from 'react';
import { WizardState } from './utils/wizard-types';
import { mapSectionKey, trackClick } from '@utils/tracking/tracking';

const SLIDES_WITHOUT_BUTTON = ['houseType', 'householdSize', 'hasVehicle', 'vehicleType'];

type UseNavigateWithoutButtonProps = {
  wizardState: WizardState;
  updateWizard: (isWizardClickedThrough?: boolean) => void;
  updateParams: (state: WizardState) => void;
};

let hasSelectedAnswer = false;

export const useNavigateWithoutButton = ({
  wizardState,
  updateWizard,
  updateParams
}: UseNavigateWithoutButtonProps) => {
  const [navigateWithoutButton, setNavigateWithoutButton] = useState(false);

  useEffect(() => {
    setNavigateWithoutButton(SLIDES_WITHOUT_BUTTON.includes(wizardState.activeSlideKey));
  }, [wizardState.activeSlideKey]);

  useEffect(() => {
    if (navigateWithoutButton) {
      hasSelectedAnswer = Boolean(wizardState.answers[wizardState.activeSlideKey]);
      updateParams(wizardState);
    }
  }, [wizardState.answers]);

  useEffect(() => {
    if (navigateWithoutButton && hasSelectedAnswer) {
      updateWizard();

      hasSelectedAnswer = false;

      if (wizardState.activeSlideKey !== 'roofDetails') {
        trackClick({
          label: 'Weiter',
          element: mapSectionKey[wizardState.activeSlideKey].label,
          funnelStep: mapSectionKey[wizardState.activeSlideKey].funnelStep
        });
      }
    }
  }, [wizardState.answers, hasSelectedAnswer]);

  return navigateWithoutButton;
};
